import React from 'react';

import { Field } from '@hrlogics/react-components/form';

import { TextField } from 'src/components/finalForm';

import { InboxFilterFieldProps, InboxFilterFormFields } from '../types';

export const InboxFilterEmployeeField: React.FC<InboxFilterFieldProps> = ({ disabled }) => (
  <Field
    fullWidth
    component={TextField}
    name={InboxFilterFormFields.employee}
    label="Employee"
    disabled={disabled}
  />
);
